<template>
  <div>
    <vxe-form
        title-align="right"
        title-width="110"
        :data="newPhone"
        @submit="changePhone()"
    >
      <vxe-form-item title="旧手机号:" field="oldNum" :title-width="100" title-align="right" span="24">
        <span>{{ newPhone.oldNum }}</span>
      </vxe-form-item>
      <vxe-form-item title="系统手机号:" v-if="!isComp" field="isSystemPhone" :title-width="100" title-align="right"
                     span="24">
        <RadioGroup v-model="newPhone.isSystemPhone" @change="changePhoneType">
          <Radio :label="1">是</Radio>
          <Radio :label="0" style="margin-left: 20px;">否</Radio>
        </RadioGroup>
      </vxe-form-item>
      <vxe-form-item title="新手机号:" field="num" :title-width="100" title-align="right" span="24">
        <vxe-input v-model="newPhone.num" :disabled="!isComp && newPhone.isSystemPhone === 1"></vxe-input>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 10px">
        <vxe-button style="border-radius: 5px;" @click="cancel">取消</vxe-button>
        <vxe-button type="submit" status="primary" style="border-radius: 5px;">确认</vxe-button>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="wyTip" position="center" title="消息通知">
      <div style="display: flex; flex-direction: column">
        <div style="display: flex; align-items: center">
          <img v-if="msgErr" src="@/assets/images/common/msgSuccess.png" style="width: 22px;height: 22px;"/>
          <img v-else src="@/assets/images/common/info.png" style="width: 22px;height: 22px;"/>
          <span style="margin-left: 10px">{{ msg }}</span>
        </div>
        <div style="margin-left: auto; margin-top: 20px">
          <Button style="border-radius: 5px" @click="cancelCreate">返回编辑</Button>
          <Button type="primary" style="margin-left: 10px; border-radius: 5px" @click="update">确认变更
          </Button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>
<script>
import {apiPost} from "@/utils/api";
import {hideLoading, showLoading} from "@/utils/util";
import $api from "@/apiProvider";

export default {
  props: {
    isComp: {
      type: Boolean,
      default: false
    },
    isUser: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      wyTip: false,
      msgErr: false,
      msg: '',
      id: null,
      newPhone: {
        oldNum: null,
        num: null,
        isSystemPhone: null,
      }
    }
  },
  methods: {
    changePhoneType() {
      this.newPhone.num = null;
    },
    setUpdate(row) {
      this.id = row.userIdClient;
      this.newPhone.oldNum = row.regisiterNum;
      if (this.isUser) {
        this.newPhone.oldNum = row.loginName;
        this.id = row.id;
      }
      if (this.isComp) {
        this.id = row.id;
      }
      this.newPhone.isSystemPhone = row.isSystemPhone ? row.isSystemPhone : 0;
    },
    async changePhone() {
      if (this.newPhone.isSystemPhone !== 1) {
        if (!this.newPhone.num) {
          this.$XModal.alert({
            message: "请输入新手机号",
            status: "error",
          });
          return
        }
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(this.newPhone.num);
        if (!validPhone) {
          this.$XModal.alert({
            message: "请输入正确的手机号",
            status: "error",
          });
          return
        }
      }

      showLoading();
      this.params = {};
      this.params.id = this.id;
      this.params.registerNum = this.newPhone.num;
      this.params.isSystemPhone = this.newPhone.isSystemPhone ? this.newPhone.isSystemPhone : 0;
      if (this.isComp) {
        this.action = 'baseUserSign/editRegisterNumComp';
        this.update();
      } else {
        this.action = 'baseUserSign/editRegisterNumClient';
        if (this.newPhone.isSystemPhone === 0) {
          this.getWYMIdlephoneCheck();
        } else {
          this.update();
        }
      }
    },
    async update() {
      let res = await apiPost("api/auth/", this.action, this.params);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("变更成功");
        this.$emit('afterChange');
        this.$emit('close');
      } else {
        this.$Message.error(res.message);
      }
    },
    async getWYMIdlephoneCheck() {
      showLoading();
      let res = await $api.gcdUser.post("getAliphoneCheck", {
        regisiterNum: this.newPhone.num
      });
      hideLoading();
      if (res.status === 1) {
        let data = res.data;
        let phoneInfo = res.data.phoneInfo[0];
        if (data.status === 2) {
          this.msg = '校验失败';
          this.wyTip = true;
          this.msgErr = data.isPayed === 1;
        }
        this.params.regisiterNumState = phoneInfo.aliStatus;
        let errMsg = {
          2:'手机号停机',
          6:'手机号关机',
          0:'手机号空号',
          7:'手机号疑似关机',
          8:'手机号忙',
        }

        if(phoneInfo.aliStatus === null) {
          this.msg = phoneInfo.message;
          this.wyTip = true;
        } else if (phoneInfo.aliStatus === 1) {
          this.params.carrier = phoneInfo.carrier
          this.update();
        } else {
          this.msg = errMsg[phoneInfo.aliStatus] ?? "手机号未知";
          this.wyTip = true;
          this.msgErr = data.isPayed === 1;
        }

        // if (phoneInfo.aliStatus === 0) {
        //   this.msg = '该手机号为空号';
        //   this.wyTip = true;
        //   this.msgErr = data.isPayed === 1;
        // } else if(phoneInfo.aliStatus === null) {
        //   this.msg = phoneInfo.message;
        //   this.wyTip = true;
        // } else {
        //   this.update();
        // }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelCreate() {
      this.wyTip = false;
      this.msg = '';
    },
    cancel() {
      this.$emit('close');
    }
  }
}
</script>
<style>

</style>